export const NO_CATEGORY = '__no_category__' as const
export const NO_LOCATION = '__no_location__' as const
export const NO_LIFECYCLE = '__no_lifecycle__' as const

export type HazardAdequacyFilter =
  | 'all'
  | 'not_adequately_reduced'
  | 'adequately_reduced'

export type HazardSourceFilter = 'all' | 'USER' | 'AGENT'

export type HazardCategoryFilter = 'all' | typeof NO_CATEGORY | string

export type HazardLocationFilter = 'all' | typeof NO_LOCATION | string

export type HazardListFilters = {
  adequacy: HazardAdequacyFilter
  category: HazardCategoryFilter
  location: HazardLocationFilter
  ehsrClauseIds: string[]
  includeNoEhsr: boolean
  lifecycles: string[]
  source: HazardSourceFilter
}

export const defaultHazardListFilters: HazardListFilters = {
  adequacy: 'all',
  category: 'all',
  location: 'all',
  ehsrClauseIds: [],
  includeNoEhsr: false,
  lifecycles: [],
  source: 'all',
}

export function countActiveHazardListFilters(filters: HazardListFilters): number {
  let count = 0
  if (filters.adequacy !== 'all') {
    count++
  }
  if (filters.category !== 'all') {
    count++
  }
  if (filters.location !== 'all') {
    count++
  }
  if (filters.ehsrClauseIds.length > 0 || filters.includeNoEhsr) {
    count++
  }
  if (filters.lifecycles.length > 0) {
    count++
  }
  if (filters.source !== 'all') {
    count++
  }
  return count
}
